import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const Challenge = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="lg:py-16 lg:px-12 px-5 py-12 bg-bgDefault text-white">
      <div className="container mx-auto max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            A Middle Eastern Ministry of Road Transportation faced unprecedented challenges in managing traffic data
            as the nation prepared to host FIFA World Cup 2022. With millions of visitors expected and the entire
            world watching, the Ministry needed a robust, scalable traffic management platform to prevent congestion,
            ensure safety, and maintain smooth traffic flow across the country. Their existing systems couldn't handle
            the complexity of integrating data from 500,000+ vehicles, multiple traffic sensors, CCTV cameras, and
            manual surveys into a unified platform. Critical decisions for infrastructure planning, road expansion,
            and traffic optimization for the Master Plan depended on accurate GIS-based visualizations that the legacy
            system simply couldn't provide.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li data-aos="fade-left" data-aos-delay="250">Processing and integrating traffic data from 500,000+ vehicles daily with data from sensors, CCTV cameras, and manual surveys</li>
            <li data-aos="fade-left" data-aos-delay="300">Building mission-critical infrastructure to support FIFA World Cup 2022 traffic management under global scrutiny</li>
            <li data-aos="fade-left" data-aos-delay="350">Creating ArcGIS-based geospatial visualizations for real-time traffic monitoring and strategic Master Plan development</li>
            <li data-aos="fade-left" data-aos-delay="400">Designing secure, role-based access control to protect sensitive transportation infrastructure data and reduce breach risks</li>
            <li data-aos="fade-left" data-aos-delay="450">Ensuring scalability and reliability for a government-scale system handling massive concurrent data streams</li>
            <li data-aos="fade-left" data-aos-delay="500">Integrating heterogeneous data sources (IoT sensors, video analytics, GPS tracking, manual inputs) into unified platform</li>
            <li data-aos="fade-left" data-aos-delay="550">Providing real-time traffic insights for dynamic decision-making during peak event periods</li>
            <li data-aos="fade-left" data-aos-delay="600">Deploying on AWS Cloud infrastructure with Docker containerization for high availability and disaster recovery</li>
            <li data-aos="fade-left" data-aos-delay="650">Meeting strict government compliance and security standards while maintaining system performance</li>
            <li data-aos="fade-left" data-aos-delay="700">Delivering accurate traffic analytics to inform multi-billion dollar infrastructure investment decisions</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
